const CustomResourceApply = () => import('@/views/main/report/customResourceApply/CustomResourceApplyNew.vue')
export default {
  path: '/main/report/customResourceApply',
  name: 'customResourceApply',
  component: CustomResourceApply,
  children: []
}
